import { api } from './util';

/**
 * Plugin for jQuery Select2.
 */
(function ($) {
	var init = function (target) {
		var lastTerm = '';
		var isPaste = false;

		if (target.hasClass('select2-hidden-accessible')) {
			return;
		}

		var ajaxUrl = target.data('select-ajax-url');
		var language = 'cs';

		if ($.type(ajaxUrl) === 'string') {
			var minLengthData = target.data('select-min-length');
			target.select2({
				language: language,
				minimumInputLength: $.type(minLengthData) === 'number' ? parseInt(minLengthData) : 1,
				ajax: $.extend(api.getAjaxOptions(ajaxUrl), {
					delay: 250,
					data: getAjaxData(target),
					processResults: getAjaxProcessResults(target),
				}),
				templateResult: getTemplateResult(target),
				templateSelection: getTemplateSelection(target),
				tags: true,
				selectOnClose: true,
				tokenSeparators: [';'],
				tokenizer: function (params, options, callback) {
					// We need to use our own tokenizer, because we want to process both strings with and without semicolon in the end
					var originalString = params.term;
					var separators = options.get('tokenSeparators') || [];
					var { term } = params;
					var i = 0;

					var createTag =
						false ||
						function (params) {
							return {
								id: params.term,
								text: params.term,
							};
						};

					while (i < term.length) {
						var termChar = term[i];
						if ($.inArray(termChar, separators) === -1) {
							i++;
							continue;
						}

						var part = term.substr(0, i);
						var partParams = $.extend({}, params, {
							term: part.trim(),
						});
						var data = createTag(partParams);

						if (data == null) {
							i++;
							continue;
						}
						callback(data);

						// Reset the term to not include the tokenized portion
						term = term.substr(i + 1) || '';
						i = 0;
					}

					if (originalString.indexOf(';') >= 0) {
						// select2 with `tags: true` behaves strangely
						// if you paste string `ABC;BCE output contains option `ABC;BCE` (instead of just ABC and BCE)
						// we want to delete original string
						target.find(`:selected[value="${originalString}"]`).remove();
					}

					if (term !== '' && isPaste) {
						isPaste = false;
						var trimmedTerm = term.trim();
						if (trimmedTerm === '') {
							return { term: '' };
						}

						callback(
							createTag(
								$.extend({}, params, {
									term: trimmedTerm,
								})
							)
						);

						return { term: '' };
					}

					if (originalString.indexOf(';') >= 0) {
						// select2 with `tags: true` behaves strangely
						// if you paste string `ABC;BCE output contains option `ABC;BCE` (instead of just ABC and BCE)
						// we want to delete original string
						target.find(`:selected[value="${originalString}"]`).remove();
					}

					lastTerm = params.term;

					return {
						term: term,
					};
				},
			});
			target.on('select2:unselect', removeSelectOption);
		} else {
			target.select2({
				language: language,
				minimumResultsForSearch: 10,
				data: [],
				selectOnClose: true,
				tokenSeparators: [';'],
				templateSelection: getTemplateSelection(target),
				tokenizer: function (params, options, callback) {
					// We need to use our own tokenizer, because we want to process both strings with and without semicolon in the end
					var separators = options.get('tokenSeparators') || [];
					var { term } = params;
					var i = 0;

					var createTag =
						this.createTag ||
						function (params) {
							return {
								id: params.term,
								text: params.term,
							};
						};

					while (i < term.length) {
						var termChar = term[i];

						if ($.inArray(termChar, separators) === -1) {
							i++;

							continue;
						}

						var part = term.substr(0, i);
						var partParams = $.extend({}, params, {
							term: part.trim(),
						});

						var data = createTag(partParams);

						if (data == null) {
							i++;
							continue;
						}

						callback(data);

						// Reset the term to not include the tokenized portion
						term = term.substr(i + 1) || '';
						i = 0;
					}

					if (term !== '' && isPaste) {
						isPaste = false;
						var trimmedTerm = term.trim();
						if (trimmedTerm === '') {
							return { term: '' };
						}

						callback(
							createTag(
								$.extend({}, params, {
									term: trimmedTerm,
								})
							)
						);

						return { term: '' };
					}

					lastTerm = params.term;

					return {
						term: term,
					};
				},
			});
		}

		target.on('select2:open', setSelectClass);
		target.on('select2:select', removeTitles);
		target.on('select2:unselect', preventDropdownAfterRemoval);
		$('body').on('paste', function (event) {
			isPaste = true;
		});
		removeTitles();
	};

	var getAjaxData = function (target) {
		var ajaxSearchParameter = target.data('select-search-parameter') || 'filter-all';

		return function (params) {
			var data = {};

			if (ajaxSearchParameter !== 'none') {
				data['page'] = params.page || 1;

				if (params.term && params.term.trim() !== '') {
					data[ajaxSearchParameter] = params.term;
				}
			}

			if (!data['page'] || data['page'] === 1) {
				removeDropdownOptions();
			}

			return data;
		};
	};

	var getAjaxProcessResults = function (target) {
		var resultIdProperty = target.data('select-result-id-property') || 'id';
		var resultTextProperty = target.data('select-result-text-property');
		var allowCustomTags =
			target.data('select-allow-custom-tags') !== 'false' && target.data('select-allow-custom-tags') !== false;

		return function (response, params) {
			// Show the original search in the dropdown - data-tags attribute at select does not work.
			// See https://github.com/select2/select2/issues/4298
			var results = [];
			var items = response.items || [];
			var addTermOption =
				!hasSelectedTag(target, params.term) &&
				allowCustomTags &&
				params.term &&
				params.term.trim() !== '' &&
				!params.page;
			var hasHierarchy =
				items.filter(function (item) {
					return item.hasOwnProperty('hasChildren') && item.hasChildren;
				}).length > 0;

			if (addTermOption) {
				results.push({
					id: params.term,
					text: params.term,
				});
			}

			return {
				results: results.concat(
					items.map(function (item) {
						var isParent = hasHierarchy && item.hasOwnProperty('hasChildren') && item.hasChildren;
						var isChild = hasHierarchy && item.hasOwnProperty('hasChildren') && !item.hasChildren;

						if (hasSelectedTag(target, item[resultIdProperty]) && !isParent) {
							return 0;
						}

						// Set the prefix in the item text if there is some hierarchy in items and it is a child
						// in this hierarchy. Indent it by a sequence of non-breaking spaces.
						var prefix = isChild ? repeat(String.fromCharCode(160), 4) : '';
						var text = getString(resultTextProperty, { item: item });

						return {
							id: item[resultIdProperty],
							text: prefix + text,
							item: item,
						};
					})
				),
				pagination: {
					more: response.pagination && response.pagination.currentPage < response.pagination.totalPages,
				},
			};
		};
	};

	var repeat = function (value, times) {
		var repeated = '';

		for (var i = 0; i < times; i++) {
			repeated += value;
		}

		return repeated;
	};

	var hasSelectedTag = function (target, value) {
		try {
			return target.find(`option[value='${value}']:selected`).length > 0;
		} catch (err) {
			console.warn('Target finding error', err);
			return false;
		}
	};

	var getString = function (template, data) {
		if (!data.item || !template) {
			return data.text;
		}

		if (!template.includes('$')) {
			return data.item[template];
		}

		for (var key in data.item) {
			if (data.item.hasOwnProperty(key)) {
				template = template.replace(`\${${key}}`, data.item[key]);
			}
		}

		return template;
	};

	var getTemplateResult = function (target) {
		return function (data) {
			var template = target.data('select-result-template');
			return getString(template, data);
		};
	};

	var getTemplateSelection = function (target) {
		var titleProperty = target.data('select-result-title-property');

		return function (data) {
			var text = data.text.replace(new RegExp(String.fromCharCode(160), 'g'), '');
			var textElement = $(`<span class="select2-selection__choice__text">${text}</span>`);
			var title = getString(titleProperty, data);

			if (data.item && titleProperty && data.item[titleProperty] && data.item[titleProperty].trim() !== '') {
				textElement.attr('title', title);
			} else if (data.element && $(data.element).attr('title') && $(data.element).attr('title').trim() !== '') {
				textElement.attr('title', $(data.element).attr('title'));
			}

			return textElement;
		};
	};

	var destroy = function (target) {
		target.select2('destroy');
	};

	/**
	 * Remove options from select AJAX dropdown.
	 *
	 * This method prevents options from previous search to appear.
	 */
	var removeDropdownOptions = function () {
		$('.select2-results__option:not(.loading-results)').remove();
	};

	/**
	 * In case of AJAX selects, remove the option, so it is added in the end next time.
	 *
	 * @param {object} event Event data.
	 */
	var removeSelectOption = function (event) {
		try {
			$(event.target).find(`option[value='${event.params.data.id}']`).remove();
		} catch (err) {
			console.warn(err);
		}
	};

	/**
	 * Prevent dropdown to appear after a tag is removed.
	 *
	 * @param {object} event Event data.
	 */
	var preventDropdownAfterRemoval = function (event) {
		if (!event.params.originalEvent) {
			return;
		}

		event.params.originalEvent.stopPropagation();
	};

	var setSelectClass = function (e) {
		$('.select2-container').addClass($(e.target).closest('.search-form-item').find('.filter-type').val());
	};

	var removeTitles = function () {
		setTimeout(function () {
			$('.select2-selection__choice').removeAttr('title');
		}, 150);
	};

	$.fn.jsSelect = function (action) {
		if (action === 'destroy') {
			destroy(this);
		} else {
			this.each(function () {
				init($(this));
			});
		}

		return this;
	};
})(jQuery);

(function () {
	if (jQuery && jQuery.fn && jQuery.fn.select2 && jQuery.fn.select2.amd) var e = jQuery.fn.select2.amd;
	return (
		e.define('select2/i18n/cs', [], function () {
			function e(e, t) {
				switch (e) {
					case 2:
						return t ? 'dva' : 'dvě';
					case 3:
						return 'tři';
					case 4:
						return 'čtyři';
				}
				return '';
			}

			return {
				errorLoading: function () {
					return 'Výsledky nemohly být načteny.';
				},
				inputTooLong: function (t) {
					var n = t.input.length - t.maximum;
					return n == 1
						? 'Prosím, zadejte o jeden znak méně.'
						: n <= 4
						? `Prosím, zadejte o ${e(n, !0)} znaky méně.`
						: `Prosím, zadejte o ${n} znaků méně.`;
				},
				inputTooShort: function (t) {
					var n = t.minimum - t.input.length;
					return n == 1
						? 'Prosím, zadejte ještě jeden znak.'
						: n <= 4
						? `Prosím, zadejte ještě další ${e(n, !0)} znaky.`
						: `Prosím, zadejte ještě dalších ${n} znaků.`;
				},
				loadingMore: function () {
					return 'Načítají se další výsledky…';
				},
				maximumSelected: function (t) {
					var n = t.maximum;
					return n == 1
						? 'Můžete zvolit jen jednu položku.'
						: n <= 4
						? `Můžete zvolit maximálně ${e(n, !1)} položky.`
						: `Můžete zvolit maximálně ${n} položek.`;
				},
				noResults: function () {
					return 'Nenalezeny žádné položky.';
				},
				searching: function () {
					return 'Vyhledávání…';
				},
			};
		}),
		{ define: e.define, require: e.require }
	);
})();
